import React, { useEffect, useState } from 'react';
import { APP_CONST } from '../../../constants';
import { 
    GeckoCard, 
    GeckoAlert, 
    GeckoBtn,
    Spinner
} from '../../../components';
import { $state, $stateParams } from '../../../router';
import { Auth, ClientManager } from '../../../services';
import ErrorTracker from '../../../services/ErrorTracker';
import ProfileSelector from '../../../components/ProfileSelector';
import Redirect from '../../../services/Redirect';

const Integration = (props) => {
    const [error, setError] = useState(null);
    const [issueInFlight, setIssueInFlight] = useState(false);

    const enableAutoRedirect = ($stateParams.ar && $stateParams.ar === 'false' ? false : true);

    const callback = (response) => {
        callbackToOpener(response);
    }

    const selectGeckoFormAccount = (geckoFormAccountId) => {
        setIssueInFlight(true);

        return issueIntegrationTokens($stateParams.accountId, geckoFormAccountId).then((response) => {
            callback(response);
        }).catch((err) => {
            if (err instanceof Error) {
                ErrorTracker.captureException(err);
                setError(err.message);
            } else if (err.Error) {
                ErrorTracker.captureException(err.Error);
                setError(err.Error);
            } else {
                ErrorTracker.captureException(err);
                setError(err);
            }

            setIssueInFlight(false);
        });
    };  

    const onSelectProfile = (profile) => {
        selectGeckoFormAccount(profile.AccountId);
    }

    useEffect(() => {
        if (!$stateParams.accountId) {
            setError('No GeckoChat account found');
        }
    }, []);

    if (error) {
        return (
            <div style={{ margin: '0 15px 15px 15px' }}>
                <GeckoAlert type={APP_CONST.ALERT_TYPE_DANGER}>
                    {error}
                </GeckoAlert>

                <div style={{ paddingTop: '15px' }}>
                    <LogoutButton />
                </div>
            </div>
        );
    }

    if (issueInFlight) {
        return (
            <GeckoCard padded={true}>
                <Loading />
            </GeckoCard>
        );
    }

    return(
        <div id="module-select-profile">
            <GeckoCard padded={true}>
                <ProfileSelector 
                    client="integration" 
                    app="geckoform" 
                    onSelectProfile={onSelectProfile} 
                    autoRedirect={enableAutoRedirect}
                    onError={(err) => setError(err.message)}
                />
            </GeckoCard>

            <LogoutButton />
        </div>
    );
};

const issueIntegrationTokens = (geckoChatAccountId, geckoFormAccountId) => {
    return Auth.integration.issue(geckoChatAccountId, geckoFormAccountId);
}

const LogoutButton = () => {
    return (
        <div>
            <GeckoBtn
                name="Logout"
                icon={'sign-out-alt'}
                type={APP_CONST.BTN_TYPE_DANGER}
                handler={() => {
                    Redirect.set(window.location.href);

                    $state.go('logout', {
                        client: ClientManager.client(),
                        app: ClientManager.app(),
                    });
                }}
                className="float-left"
            />
        </div>
    );
}

const Loading = () => {
    return (
        <div className="row text mt-3 mb-3">
            <div className="col d-flex flex-column align-items-center">
                <Spinner size="small" color="blue" />
            </div>
        </div>
    );
}

const callbackToOpener = (payload) => {
    if (window.opener) {
        window.opener.postMessage(JSON.stringify(payload), '*');
    } else {
        console.error('No opener available');
    }
}

export default Integration;
